<!-- Icon Editor -->
<mat-form-field class="flex-auto w-full" [class]="externalClass" (click)="openDialog()" >
    <mat-label *ngIf="label"> {{label}} </mat-label>
    <input class="truncate mr-2" 
    readonly 
    [value]="$safeNavigationMigration(selectedIcon?.displayName)"
    matInput>
    <fa-icon matSuffix [icon]="$safeNavigationMigration(selectedIcon?.icon)" class="icon-size-6" ></fa-icon>
</mat-form-field>
